import React, { useEffect } from 'react';
import LandingHeader from '../00-shared/LandingHeader';
import LandingFooter from '../00-shared/LandingFooter';
import { GlobalStyles } from '../00-shared/styles';
import { highlightColor } from '../00-shared/constants';
import ContactFormSection from './51-ContactFormSection';

import FAQSection from './53-ContactFAQSection';

const ContactPage: React.FC = () => {
    // Scroll to top when page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -100px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('fade-in-up');
                }
            });
        }, observerOptions);

        document.querySelectorAll('.observe-fade').forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <div className="min-h-screen bg-black text-white transition-colors duration-300" style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif" }}>
            <GlobalStyles />
            <LandingHeader highlightColor={highlightColor} />
            
            <ContactFormSection highlightColor={highlightColor} />
            <FAQSection />
            
            <LandingFooter highlightColor={highlightColor} />
        </div>
    );
};

export default ContactPage;
